import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useBrokerName } from "../broker";

export default function AuthCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const broker = useBrokerName();
  const [message, setMessage] = useState("Processing login...");

  const status = params.get("status");
  const user = params.get("user");
  const error = params.get("message");

  useEffect(() => {
    if (status === "success") {
      setMessage(`Logged in as ${user || "user"}. Redirecting...`);
      const timer = setTimeout(() => navigate("/"), 2000);
      return () => clearTimeout(timer);
    }
    if (status === "error") {
      setMessage(`Login failed: ${error || "Unknown error"}`);
    }
    return undefined;
  }, [status, user, error, navigate]);

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="bg-gray-900 border border-gray-800 rounded-lg p-8 text-center max-w-md">
        {status === "success" ? (
          <>
            <div className="text-emerald-400 text-5xl mb-4">✓</div>
            <h2 className="text-xl font-bold text-hi mb-2">Connected to {broker}</h2>
          </>
        ) : status === "error" ? (
          <>
            <div className="text-red-400 text-5xl mb-4">✗</div>
            <h2 className="text-xl font-bold text-hi mb-2">Login Failed</h2>
          </>
        ) : (
          <div className="text-gray-400 text-5xl mb-4 animate-spin">⟳</div>
        )}
        <p className="text-gray-400">{message}</p>
      </div>
    </div>
  );
}
